<template>
    <secondary-button
        :loading="loading"
        :bind-props="bindProps"
        color="error"
        @click="$emit('click', $event)"
    >
        <slot />
    </secondary-button>
</template>

<script>
export default {
    name: "DangerButton",
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        bindProps: {
            type: Object,
            default: null
        },
    }
}
</script>
